var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "170.833333px",
    height: "170.833333px",
    viewBox: "0 0 170.833333 170.833333",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4166666,0 C38.3333332,0 0,38.3333332 0,85.4166666 C0,132.5 38.3333332,170.833333 85.4166666,170.833333 C132.5,170.833333 170.833333,132.5 170.833333,85.4166666 C170.833333,38.3333332 132.5,0 85.4166666,0 Z M41.6666666,143.75 C41.6666666,119.583333 61.25,100 85.4166666,100 C109.583333,100 129.166667,119.583333 129.166667,143.75 C117.083333,152.916667 101.666667,158.333333 85.4166666,158.333333 C69.1666666,158.333333 53.75,152.916667 41.6666666,143.75 Z M66.6666666,68.75 C66.6666666,58.3333334 75,50 85.4166666,50 C95.8333332,50 104.166667,58.3333334 104.166667,68.75 C104.166667,79.1666666 95.8333332,87.5 85.4166666,87.5 C75,87.5 66.6666666,79.1666666 66.6666666,68.75 Z M140.416667,132.916667 C136.666667,114.166667 123.75,98.75 106.25,91.6666666 C112.5,85.8333332 116.25,77.9166666 116.25,68.75 C116.25,51.6666666 102.083333,37.5 85,37.5 C67.9166666,37.5 53.75,51.6666666 53.75,68.75 C53.75,77.9166666 57.5,85.8333334 63.75,91.6666666 C46.25,98.75 33.3333334,114.166667 29.5833332,132.916667 C18.7499998,120 11.6666666,103.75 11.6666666,85.4166666 C11.6666666,45.4166666 44.5833332,12.5 84.5833332,12.5 C124.583333,12.5 158.333333,45.4166666 158.333333,85.4166666 C158.333333,103.75 151.666667,120 140.416667,132.916667 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7ae9af5bc6fbb91df64e77cc2ce84295.svg";
export { ForwardRef as ReactComponent };